import React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const ConflictView = ({ onCancel, changeMethods }) => (
  <React.Fragment>
    <DialogTitle children="Attention" />
    <DialogContent>
      Vous ne pouvez pas payer un artisan par cheque et par virement
      en meme temps.
    </DialogContent>
    <DialogActions>
      <Button
        onClick={() => changeMethods('cheque')}
        color="primary"
        children="Je passe tout par chèque"
      />
      <Button
        onClick={() => changeMethods('virement')}
        color="primary"
        autoFocus
        children="Je passe tout par virement"
      />
      <Button
        onClick={onCancel}
        color="primary"
        autoFocus
        children="Annuler"
      />
    </DialogActions>
  </React.Fragment>
);

export default ConflictView;
